import { createSelector } from "reselect";

import { isCartAsync } from "./get-cart-completed";
import { getPage } from "./state-accessors";
import { PAGES } from "../constants/pages";

export const isAsyncCart = createSelector(
  [getPage, isCartAsync],
  (page, is_async_cart) => {
    return page === PAGES.ASYNC_CART || is_async_cart;
  }
);
